import { render, staticRenderFns } from "./UserBlackList.vue?vue&type=template&id=55be5575&"
import script from "./UserBlackList.vue?vue&type=script&lang=js&"
export * from "./UserBlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports